/**
 * @generated SignedSource<<aeaff25e02c1f13ecd339a2688184666>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlansList$data = {
  readonly jira: {
    readonly favouritePlans: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly planId?: AGG$Long | null;
          readonly title?: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItem">;
        };
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    };
    readonly recentPlans: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly planId?: AGG$Long | null;
          readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItem">;
        };
      } | null> | null;
    };
  };
  readonly " $fragmentType": "PlansList";
} | null;
export type PlansList$key = {
  readonly " $data"?: PlansList$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlansList">;
};

import PlanListQuery_graphql from './PlanListQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "RequiredField",
  "field": {
    "kind": "ScalarField",
    "name": "id"
  },
  "action": "LOG"
},
v2 = {
  "kind": "ScalarField",
  "name": "planId"
},
v3 = {
  "kind": "FragmentSpread",
  "name": "PlanMenuItem"
},
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURLPath"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": PlanListQuery_graphql
    }
  },
  "name": "PlansList",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "favouritePlans",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "sort": {
                      "order": "DESC"
                    },
                    "type": "PLAN"
                  }
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 15
                }
              ],
              "concreteType": "JiraFavouriteConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    }
                  ]
                },
                {
                  "concreteType": "JiraFavouriteEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              (v3/*: any*/)
                            ],
                            "type": "JiraPlan"
                          }
                        ]
                      },
                      "action": "LOG"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            "action": "LOG"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": "recentPlans",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "currentURL",
                  "variableName": "currentURLPath"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                },
                {
                  "kind": "Literal",
                  "name": "types",
                  "value": [
                    "PLAN"
                  ]
                }
              ],
              "concreteType": "JiraSearchableEntityConnection",
              "kind": "LinkedField",
              "name": "recentItems",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraSearchableEntityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "type": "JiraPlan"
                          }
                        ]
                      },
                      "action": "LOG"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            "action": "LOG"
          }
        ]
      },
      "action": "LOG"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "4536d10af216e5c7e6bd1206d1769b37";

export default node;
